import { ArrowLeft, FileText, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { InvoiceDto } from "@shared/types/InvoiceDto";

interface InvoiceHeaderProps {
  invoice: InvoiceDto;
  onBack: () => void;
  onViewInvoice: () => void;
}

export function InvoiceHeader({
  invoice,
  onBack,
  onViewInvoice,
}: InvoiceHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-start gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={onBack}
          className="mt-1"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
              <FileText className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h1 className="font-display text-2xl font-bold">
                {invoice.name}
              </h1>
              <p className="text-muted-foreground">{invoice.description}</p>
            </div>
          </div>
        </div>
      </div>

      <Button onClick={onViewInvoice} className="shrink-0">
        <ExternalLink className="h-4 w-4 mr-2" />
        View Invoice
      </Button>
    </div>
  );
}
